
import React, {FC} from 'react';
import {Dropdown} from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';

import {Action, Option, State} from './useState';

import * as styles from './styles.module.scss';

type OptionsProps = {
	state: State
	dispatch: React.Dispatch<Action>
}

const render = (option: Option) => {
	return (
		<div className={styles.option}>
			<span>{option.demo}</span>
			<span>({option.goal})</span>
		</div>
	);
};

export const Options: FC<OptionsProps> = ({state, dispatch}) => {
	const handleSelect = (key: string | null) => {
		dispatch({type: 'SELECT', id: key || ''});
	};
	return (
		<Dropdown className={styles.options} onSelect={handleSelect}>
			<Dropdown.Toggle>
				{render(state.current)}
			</Dropdown.Toggle>
			<DropdownMenu>
				{state.options.map((r, i) => (
					<Dropdown.Item eventKey={r.id} key={i}>
						{render(r)}
					</Dropdown.Item>
				))}
			</DropdownMenu>
		</Dropdown>
	);
};
